import * as React from 'react';
import { RouteComponentProps } from 'react-router-dom';
import { Upload as KendoUpload, UploadOnStatusChangeEvent, UploadOnAddEvent } from '@progress/kendo-react-upload';
import LoadingPanel from '../LoadingPanel';

type Props = RouteComponentProps<{ }>;

type State = {
    filename: string;
    isUploading: boolean;
}

export default class Upload extends React.Component<Props, State> {

    constructor(props: Props) {
        super(props);

        this.state = {
            filename: '',
            isUploading: false
        }

        this.onAdd = this.onAdd.bind(this);
        this.onStatusChange = this.onStatusChange.bind(this);
    }

    public render() {
        return <div>
            <br />
            <div className="row">
                <div className="col text-center">
                    <h1>Upload A Document</h1>
                </div>
            </div>
            <br />
            <KendoUpload
                batch={false}
                multiple={false}
                restrictions={{
                    allowedExtensions: [ '.jpeg', '.jpg', '.png', '.gif', '.pdf', '.doc', '.docx' ]
                }}
                saveUrl="/api/Document/Upload"
                saveField="file"
                saveMethod="POST"
                saveHeaders={{'Authorization': `Bearer ${localStorage.getItem('ACCESS_TOKEN')}`}}
                onBeforeUpload={() => this.setState({ isUploading: true })}
                onAdd={this.onAdd}
                onStatusChange={this.onStatusChange}
            />
            {this.state.isUploading && <LoadingPanel />}
        </div>;
    }

    private onAdd(e: UploadOnAddEvent) {
        this.setState({ filename: e.affectedFiles[0].name });
    }

    private onStatusChange(e: UploadOnStatusChangeEvent) {
        this.setState({ isUploading: false });

        if (e.response.status == 200) {
            if (this.props.location.state) {
                this.props.history.push(`/document/${e.response.response.DocumentID}`, {
                    filename: this.state.filename,
                    accountId: this.props.location.state.accountId,
                    childId: this.props.location.state.childId
                });
            } else {
                this.props.history.push(`/document/${e.response.response.DocumentID}`, {
                    filename: this.state.filename
                });
            }
        }
    }
}
